export const ru = ({
  facePage: {
    header: {
      title: 'Детали лица',
      breadcrumbs: {
        cards_and_lists: 'Картотека и списки',
        card: 'Карточка',
        face: 'Детали лица',
      },
    },
    general_info: {
      header: 'Общая информация',
      data: {
        create_time: 'Создано',
        external_id: 'ID карточки',
        lists: 'Списки',
        user_data: 'Информация',
        face_id: 'ID лица',
      },
    },
    additional_info: {
      switches: {
        attributes: 'Атрибуты',
        additional: 'Дополнительные свойства',
      },
    },
    'face info': {
      'card ID': 'ID карточки',
    },
    edit_face_info: {
      title: 'Редактирование информации о лице',
      replace_photo: 'Заменить фото',
      lists_label: 'Списки',
      information_label: 'Информация',
      success_toast: 'Информация успешно обновлена',
      card_label: 'Карточка',
      lists_hint: 'Для изменения списков перейдите в карточку',
      edit_face_button: 'Изменить данные',
    },
    same_external_id_faces: {
      title: 'Лица с тем же ID карточки',
      no_faces: 'Лица с тем же ID карточки не зарегистрированы в системе',
    },
    latest_face_events: {
      title: 'Последние события с лицом',
      no_events: 'События с данным лицом не зарегистрированы в системе',
      show_more: 'Показать ещё',
    },
    meta_information: {
      title: 'Дополнительные сведения',
      no_meta: 'Нет данных',
      download_as_json: 'Скачать JSON',
    },
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  facePage: {
    header: {
      title: 'Face details',
      breadcrumbs: {
        cards_and_lists: 'Card index and lists',
        card: 'Card',
        face: 'Face details',
      },
    },
    general_info: {
      header: 'General information',
      data: {
        create_time: 'Created',
        external_id: 'Card ID',
        lists: 'Lists',
        user_data: 'Information',
        face_id: 'Face ID',
      },
    },
    additional_info: {
      switches: {
        attributes: 'Attributes',
        additional: 'Additional properties',
      },
    },
    'face info': {
      'card ID': 'Card ID',
    },
    edit_face_info: {
      title: 'Edit Face Information',
      replace_photo: 'Replace photo',
      lists_label: 'Lists',
      information_label: 'Information',
      success_toast: 'Information has been successfully updated.',
      card_label: 'Card',
      lists_hint: 'To edit lists, go to the card',
      edit_face_button: 'Edit face info',
    },
    same_external_id_faces: {
      title: 'Faces with same card ID',
      no_faces: 'Faces with same card ID is not registered in the system',
    },
    latest_face_events: {
      title: 'Latest events with the face',
      no_events: 'Latest events with the face is not registered in the system',
      show_more: 'Show more',
    },
    meta_information: {
      title: 'Additional information',
      no_meta: 'No data',
      download_as_json: 'download JSON',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
    },
  },
}) as Record<string, unknown>;
export const ptBr = ({
  facePage: {
    header: {
      title: 'Detalhes do rosto',
      breadcrumbs: {
        cards_and_lists: 'Cartões e listas',
        card: 'Cartão',
        face: 'Detalhes do rosto',
      },
    },
    general_info: {
      header: 'Informações gerais',
      data: {
        create_time: 'Criado',
        external_id: 'ID do cartão',
        lists: 'Listas',
        user_data: 'Informação',
        face_id: 'Identificação facial',
      },
    },
    additional_info: {
      switches: {
        attributes: 'Atributos',
        additional: 'Propriedades adicionais',
      },
    },
    'face info': {
      'card ID': 'ID da ficha',
    },
    edit_face_info: {
      title: 'Editar informações da face',
      replace_photo: 'Substituir foto',
      lists_label: 'Listas',
      information_label: 'Informações',
      success_toast: 'Informações atualizadas com sucesso.',
      card_label: 'Ficha',
      lists_hint: 'Para editar listas, acesse a ficha',
      edit_face_button: 'Editar informações da face',
    },
    same_external_id_faces: {
      title: 'Rostos com o mesmo número de identificação no cartão.',
      no_faces: 'Rostos com o mesmo número de identificação de cartão não estão registrados no sistema.',
    },
    latest_face_events: {
      title: 'Últimos acontecimentos com o rosto',
      no_events: 'Os eventos mais recentes com o rosto não estão registrados no sistema.',
      show_more: 'Mostrar mais',
    },
    meta_information: {
      title: 'Informações adicionais',
      no_meta: 'No data',
      download_as_json: 'Sem dados',
    },
    common: {
      save: 'Salvar',
      cancel: 'Cancelar',
    },
  },
}) as Record<string, unknown>;
export const esEs = ({
  facePage: {
    header: {
      title: 'Detalles del rostro',
      breadcrumbs: {
        cards_and_lists: 'Índice de tarjetas y listas',
        card: 'Tarjeta',
        face: 'Detalles del rostro',
      },
    },
    general_info: {
      header: 'Información general',
      data: {
        create_time: 'Creado',
        external_id: 'ID de tarjeta',
        lists: 'Listas',
        user_data: 'Información',
        face_id: 'ID de rostro',
      },
    },
    additional_info: {
      switches: {
        attributes: 'Atributos',
        additional: 'Propiedades adicionales',
      },
    },
    'face info': {
      'card ID': 'ID de tarjeta',
    },
    edit_face_info: {
      title: 'Editar información del rostro',
      replace_photo: 'Reemplazar foto',
      lists_label: 'Listas',
      information_label: 'Información',
      success_toast: 'La información se actualizó correctamente.',
      card_label: 'Tarjeta',
      lists_hint: 'Para editar listas, vaya a la tarjeta',
      edit_face_button: 'Editar información del rostro',
    },
    same_external_id_faces: {
      title: 'Rostros con el mismo ID de tarjeta',
      no_faces: 'Rostros con el mismo ID de tarjeta no está registrado en el sistema',
    },
    latest_face_events: {
      title: 'Últimos eventos con el rostro',
      no_events: 'Últimos eventos con el rostro no está registrado en el sistema',
      show_more: 'Mostrar más',
    },
    meta_information: {
      title: 'Información adicional',
      no_meta: 'Sin datos',
      download_as_json: 'descargar JSON',
    },
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
    },
  },
}) as Record<string, unknown>;
